@if (value !== undefined && (!(value * (factor || 1) < 0.01 && value * (factor || 1) > -0.01) || value === 0)) {
    <span>{{
        (value === undefined || value === 0) && hasReplacementValue
            ? hasReplacementValue
            : value !== undefined
              ? simpleFormat
                  ? utilsService.simpleNumFormatter(value, factor)
                  : utilsService.numFormatter(value, factor)
              : 0
    }}</span>
} @else {
    <span [pTooltip]="utilsService.simpleNumFormatter(value, factor, 4)">
        {{
            (value === undefined || value === 0) && hasReplacementValue
                ? hasReplacementValue
                : value !== undefined
                  ? simpleFormat
                      ? utilsService.simpleNumFormatter(value, factor)
                      : utilsService.numFormatter(value, factor)
                  : 0
        }}
    </span>
}
